import cn from 'classnames';
import React, { useEffect, useState } from 'react';

import dayjs from 'lib/dayjs-setup';

import styles from './styles.module.scss';

const parseDate = (startDate: string, duration: number): [string, number] => {
  const currentTime = dayjs();
  const diff = dayjs(currentTime).diff(startDate);
  const remainingTime = duration - diff;
  const time = dayjs.duration(remainingTime);
  const hours = time.hours().toString().padStart(2, '0');
  const minutes = time.minutes().toString().padStart(2, '0');
  const seconds = time.seconds().toString().padStart(2, '0');

  return [`${hours}:${minutes}:${seconds}`, remainingTime];
};

const end = '00:00:00';

export const Timer: React.FC<{
  startDate: string;
  duration?: number;
  onEnd?: () => void;
  onError?: () => void;
  className?: string;
  removeAfterFinish?: boolean;

  isReturnString?: boolean;
}> = ({
  startDate,
  duration = 86400000,
  onEnd,
  onError,
  removeAfterFinish,
  className,
  isReturnString = false,
}) => {
  const [timeString, setTimeString] = useState(
    parseDate(startDate, duration)[0],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const [parsedDate, remainingTime] = parseDate(startDate, duration);
      let date = parsedDate;

      if (remainingTime <= 0) {
        // Когда закончился таймер
        date = end;
        setTimeString(date);
        clearInterval(interval);
        onEnd?.();

        return;
      }

      if (remainingTime > duration) {
        // Если что-то пошло не так (например, длительность уже превышена)
        clearInterval(interval);
        onError?.();

        return;
      }

      setTimeString(date);
    }, 1000);

    return () => clearInterval(interval);
  }, [onEnd, onError, startDate, duration]);

  if (removeAfterFinish && timeString === end) {
    return null;
  }

  if (isReturnString) {
    return (
      <>
        {timeString}
      </>
    );
  }

  const content = timeString.split('').map((char, index) => {
    return /[a-zA-Zа-яА-Я]/.test(char) ? (
      <span key={index}>{char}</span>
    ) : (
      char
    );
  });

  return <div className={cn(styles.container, className)}>{content}</div>;
};

export default Timer;
